var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackMute = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-PlaybackMute Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#484848",
  fillOpacity: 0.6,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m32.17 17.07.7.676a.413.413 0 0 1 0 .6L31.16 20l1.71 1.654a.413.413 0 0 1 0 .6l-.7.677a.444.444 0 0 1-.61 0l-1.716-1.658-1.693 1.64a.444.444 0 0 1-.611 0l-.709-.676a.427.427 0 0 1 0-.6L28.525 20l-1.694-1.637a.427.427 0 0 1 0-.6l.709-.677a.444.444 0 0 1 .61 0l1.694 1.64 1.715-1.657a.444.444 0 0 1 .611 0m-9.703 14.927c-.17 0-.338-.032-.496-.094h-.088l-.16-.077-8.296-5.742h-2.656c-.951 0-1.733-.725-1.771-1.645V15.56c.038-.92.82-1.646 1.77-1.645h2.657l8.394-5.767h.088q.267-.117.558-.146c.355-.023.704.092.969.322.265.229.423.551.439.895v21.56a1.26 1.26 0 0 1-.44.895 1.35 1.35 0 0 1-.968.322m-.992-3.213V11.088l-6.073 4.199v9.332zm-8.482-4.962V16.11h-1.585v7.712z"
})))));
export default SvgPlaybackMute;